/* eslint-disable react-hooks/exhaustive-deps */
'use client'

import { noop } from 'lodash'
import { useContext, useEffect, useMemo } from 'react'
import { Box } from '@mui/material'
import PlanItem from './PlanItem'
import { Logger, PageContext, Section } from '@wolfdanepug/common-react'

export default function BuilderForm({ plan, items, weights = [], updatePrice = noop, quote }: any) {
	useEffect(() => {
		Logger.log('[BuilderForm]', plan, items, weights)
	}, [plan, items, weights])

	const { setPageData, usePageData } = useContext(PageContext)
	const data: any = usePageData()

	const quoteData = useMemo(() => {
		return plan && quote ? quote?.data?.find((q: any) => q.plan === plan.id) : null
	}, [quote?.data, plan.id])

	const defaultSelected = useMemo(() => {
		return (
			quoteData?.products ||
			plan?.products?.map(({ id }: any) => ({ product: id, weight: plan.meal })) ||
			[]
		)
	}, [quoteData, plan])

	useEffect(() => {
		setPageData({ plan: plan.id, selected: defaultSelected, quote: quote?.id || null })
	}, [plan.id, defaultSelected, quote?.id])

	const onChange = (selected: any) => {
		setPageData({ ...data, selected })
	}

	// Group products by price
	const groupedByPrice =
		items?.reduce((acc: any, item: any) => {
			const price = item.price
			if (!acc[price]) acc[price] = []
			acc[price].push(item)
			return acc
		}, {}) || {}

	const handleChange = (isSelected: boolean, item: any) => {
		if (isSelected) {
			const copy = [...data.selected]
			const existIndex = copy.findIndex(({ product }: any) => product === item.product)
			if (existIndex > -1) {
				copy[existIndex].weight = item.weight
			} else {
				copy.push(item)
			}
			onChange(copy)
		} else {
			onChange(data.selected.filter(({ product }: any) => product !== item.product))
		}
	}

	// convert productsByPrice to array
	const itemsByPriceArray = Object.entries(groupedByPrice).map(([price, products]: any) => ({
		price,
		items: products
	}))

	return (
		<Box sx={styles.root}>
			<Section sx={styles.section}>
				<Box sx={{ display: 'flex', flexDirection: 'row', gap: 6, width: '100%' }}>
					{itemsByPriceArray?.length > 0 &&
						itemsByPriceArray.map((group: any) => {
							return (
								<Box key={`price-${group.price}`} sx={styles.group}>
									<Box sx={styles.item}>
										{group.items.map((item: any) => {
											const selectedItem = data?.selected?.find(
												(selected: any) => selected.product === item.id
											)
											const itemSelected = Boolean(selectedItem)
											const quoteWeight =
												quoteData?.products.find((q: any) => q.product === item.id)?.weight || null

											Logger.log('[ItemsSelect]', quoteWeight, item)
											return (
												<PlanItem
													key={item.id}
													{...item}
													availableWeights={weights}
													// allowWeightSelect={true}
													currentWeight={plan?.meal}
													quoteWeight={quoteWeight}
													actionLabel={'Select'}
													selected={itemSelected}
													onChange={(selected: boolean) =>
														handleChange(selected, { product: item.id, weight: plan.meal })
													}
													onWeightChange={(weight: number) =>
														handleChange(itemSelected, { product: item.id, weight })
													}
													updatePrice={updatePrice}
												/>
											)
										})}
									</Box>
								</Box>
							)
						})}
				</Box>
			</Section>
		</Box>
	)
}

const styles = {
	root: {
		width: '100%'
	},
	section: {
		root: {},
		container: {
			display: 'flex',
			justifyContent: 'center'
		}
	},
	divider: {
		mt: 2,
		mb: 2
	},
	group: {
		display: 'flex',
		flex: 1,
		flexDirection: 'column'
	},
	item: {
		display: 'flex',
		flexDirection: 'row',
		flex: 1,
		// justifyContent: 'space-between',
		pl: 3,
		pr: 3,
		gap: 3
	}
}
